import { defineMessages } from 'react-intl';

export default defineMessages({
    BuildingUnderwriter: {
        id: 'sph.components.SgSphDeclarationsBullets.BuildingUnderwriter',
        defaultMessage: 'My underwriter for Buildings will be '
    },
    ContentsUnderwriter: {
        id: 'sph.components.SgSphDeclarationsBullets.ContentsUnderwriter',
        defaultMessage: 'My underwriter for Contents will be '
    },
    ChangedUnderwriter: {
        id: 'sph.components.SgSphDeclarationsBullets.ChangedUnderwriter',
        defaultMessage: 'My underwriter will be '
    }
});
